import * as React from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { Link } from 'react-router-dom'
import Rating from '@mui/material/Rating'
// import AI from '../Image/AI.jpg'
// import ML from '../Image/ML.jpg'
// import WD from '../Image/WD.webp'
// import Robotics from '../Image/Robotics.jpg'
// import Cyber_Security from '../Image/Cyber_Security.jpg'
// import Cloud_Computing from '../Image/Cloud_Computing.jpg'
// import Human_Resource from '../Image/Human_Resource.jpg'
// import Python from '../Image/Python.jpg'
// import Finance from '../Image/Finance.jpg'
// import Business_Analytics from '../Image/Business_Analytics.jpg'
// import AutoCAD from '../Image/AutoCAD.jpg'
// import Digital_Marketing from '../Image/Digital_Marketing.jpg'
// import VLSI from '../Image/VLSI.jpg'
// import Internet_Of_Things from '../Image/Internet_Of_Things.jpg'
import AI from '../Image/AI.webp'
import ML from '../Image/ML.webp'
import WD from '../Image/WD.webp'
import Robotics from '../Image/Robotics.webp'
import Cyber_Security from '../Image/Cyber_Security.webp'
import Cloud_Computing from '../Image/Cloud_Computing.webp'
import Human_Resource from '../Image/Human_Resource.webp'
import Python from '../Image/Python.webp'
import Finance from '../Image/Finance.webp'
import Business_Analytics from '../Image/Business_Analytics.webp'
import AutoCAD from '../Image/AutoCAD.webp'
import Digital_Marketing from '../Image/Digital_Marketing.webp'
import VLSI from '../Image/VLSI.webp'
import DS from "./image/DS.avif"
import Internet_Of_Things from '../Image/Internet_Of_Things.webp'
import { BsArrowUpRight } from 'react-icons/bs'
import { FaPlus } from 'react-icons/fa6'
import { FiArrowRightCircle } from 'react-icons/fi'

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  }
}

export default function VerticalTabs() {
  const [value, setValue] = React.useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  const courses = [
    {
      title: 'Artificial Intelligence',
      description:
        'Get started on an exciting new adventure in AI with our all-encompassing training program. This course will...',
      imageUrl: AI,
      link: '/Artificial-Intelligence',
      alt: 'Artificial-Intelligence',
      rating:5,
    },
    {
      title: 'Cyber Security',
      description:
        'With our in-depth course covering key ideas, network history, operating system fundamentals, and ethical...',
      imageUrl: Cyber_Security,
      link: '/Cyber-Security',
      alt: 'Cyber-Security',
      rating: 4.7,
    },
    {
      title: 'Human Resource',
      description:
        'In-depth study of Human Resource Management (HRM) will be provided in this course. Examine all aspects of HR, including performance...',
      imageUrl: Human_Resource,
      link: '/Human-Resources',
      alt: 'Human-Resources',
      rating: 4.5,
    },
    {
      title: 'Digital Marketing',
      description:
        'Take a deep dive into the exciting world of marketing management and digital marketing. This course covers everything from comprehending...',
      imageUrl: Digital_Marketing,
      link: '/Digital-Marketing',
      alt: 'Digital-Marketing',
      rating: 4.8,
    },
    {
      title: 'VLSI',
      description:
        'VLSI technology has revolutionized the electronics industry by enabling the development of increasingly complex and powerful integrated...',
      imageUrl: VLSI,
      link: '/Vlsi-Design',
      alt: 'VLSI',
      rating: 4,
    },
    {
      title: 'AutoCAD',
      description:
        'Learn AutoCAD from the ground up with our engaging course materials. Our training covers all the bases, from geometry creation and...',
      imageUrl: AutoCAD,
      link: '/Autocad',
      alt: 'AutoCAD',
      rating: 4.2,
    },
    {
      title: 'Internet Of Things',
      description:
        'IoT has the potential to revolutionize industries, enhance connectivity, and drive innovation by enabling smarter, more efficient...',
      imageUrl: Internet_Of_Things,
      link: '/Internet-Of-Things',
      alt: 'Internet-Of-Things',
      rating: 4.3,
    },
    {
      title: 'Robotics',
      description:
        'With our extensive course, take a revolutionary step into the world of robotics. Explore the laws, types, and components of robot...',
      imageUrl: Robotics,
      link: '/Robotics',
      alt: 'Robotics',
      rating: 4.5,
    },
    {
      title: 'Finance',
      description:
        'With our extensive curriculum that covers Treasury duties, Corporate Finance, Portfolio Management, Financial Risk...',
      imageUrl: Finance,
      link: '/Finance',
      alt: 'Finance',
      rating: 4.7,
    },
    {
      title: 'Business Analytics',
      description:
        'With our in-depth training, you can enter the exciting field of Business Analytics. Gain familiarity with Python while studying...',
      imageUrl: Business_Analytics,
      link: '/Business-Analytics',
      alt: 'Business-Analytics',
      rating: 4.5,
    },
    {
      title: 'Web Development',
      description:
        'With our course on HTML, CSS, Bootstrap, JavaScript, OOP, DOM manipulation, jQuery, Node.js, and...',
      imageUrl: WD,
      link: '/Web-Development',
      alt: 'Web-Development',
      rating:5,
    },
    {
      title: 'Machine Learning',
      description:
        'With our course, take a thorough exploration of the field of machine learning. Explore both supervised and...',
      imageUrl: ML,
      link: '/Machine-Learning',
      alt: 'Machine-Learning',
      rating:5,
    },
    {
      title: 'Artificial Intelligence',
      description:
        'Get started on an exciting new adventure in AI with our all-encompassing training program. This course will...',
      imageUrl: AI,
      link: '/Artificial-Intelligence',
      alt: 'Artificial-Intelligence',
      rating: 5,
    },
    {
      title: 'Cloud Computing',
      description:
        'Discover the ever-changing realm of cloud computing with our all-inclusive course! Learn about Azure services...',
      imageUrl: Cloud_Computing,
      link: '/Cloud-Computing',
      alt: 'Cloud-Computing',
      rating: 4.8,
    },
    {
      title: 'Data Science',
      description:
        'Data Science is the field of extracting insights from data using analysis, statistics, and machine learning...',
      imageUrl: DS,
      rating: 4,
      link: '/Data-Science',
      alt: 'Data Science',
      rating: 4.5,
    },
    {
      title: 'Python',
      description:
        'Take a thorough look at Python and learn about data structures, advanced concepts, and...',
      imageUrl: Python,
      rating: 4,
      link: '/Python-Programming',
      alt: 'Python-Programming',
      rating: 4.5,
    },
    
    // {
    //   title: 'Python',
    //   description:
    //     'Take a thorough look at Python and learn about data structures, advanced concepts, and...',
    //   imageUrl: Python,
    //   rating: 4,
    //   link: '/Python-Programming',
    //   alt: 'Python-Programming',
    //   rating: 4.5,
    // },
  ]

  const CourseWindow = ({ courses }) => (
    <div className="container">
      {courses.map((course, index) => (
        <div className="" key={index}>
          <Link className="Program_card_link" to={course.link}>
            <div className="border shadow-sm Program_card pb-1">
              <div className="p-3">
                <img
                  className="border rounded"
                  src={course.imageUrl}
                  alt={course.title}
                  onContextMenu={(e) => e.preventDefault()}
                />
              </div>
              <div className="px-3">
                <div className="row">
                  <div className="col-md-10">
                    <h2 className="pt-2">{course.title}</h2>
                  </div>
                  <div className="col-md-2">
                    <BsArrowUpRight className="text-end" />
                  </div>
                  <p className="pt-1">{course.description}</p>
                </div>
                <h6>
                  <b>Duration:</b> 2 Months
                </h6>
                <h6>Price: ₹ 8,000</h6>
                <h5 className="fw-normal pt-1">
                  {course.rating}{' '}
                  <Rating
                    name={`rating-${index}`}
                    size="small"
                    defaultValue={course.rating}
                    precision={0.1}
                    readOnly
                  />
                </h5>
              </div>
            </div>
          </Link>
        </div>
      ))}
    </div>
  )

  const firstTabCourses = courses.slice(0, 2)
  const secondTabCourses = courses.slice(2, 4)
  const thiredTabCourses = courses.slice(4, 6)
  const fourthTabCourses = courses.slice(6, 8)
  const fifthTabCourses = courses.slice(8, 10)
  const sixTabCourses = courses.slice(10, 12)
  const sevenTabCourses = courses.slice(12, 14)
  const eightTabCourses = courses.slice(14, 16)

  return (
    <Box
      sx={{
        flexGrow: 1,
        bgcolor: 'background.paper',
        display: 'flex',
      }}
    >
      <Tabs
        orientation="vertical"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{ minWidth: 300 }}
      >
        <Tab
          label="AI CyberGuard"
          className="border rounded bg-dark text-white fw-bold mx-3 px-5 my-2"
          {...a11yProps(0)}
        />
        <Tab
          label="HR Digital"
          className="border rounded bg-dark text-white fw-bold mx-3 px-5 my-2"
          {...a11yProps(1)}
        />
        <Tab
          label="VLSI CAD"
          className="border rounded bg-dark text-white fw-bold mx-3 px-5 my-2"
          {...a11yProps(1)}
        />
        <Tab
          label="IoT Machines"
          className="border rounded bg-dark text-white fw-bold mx-3 px-5 my-2"
          {...a11yProps(1)}
        />
        <Tab
          label="BizFinance Analytics"
          className="border rounded bg-dark text-white fw-bold mx-3 px-5 my-2"
          {...a11yProps(1)}
        />
        <Tab
          label="WebIntelligence"
          className="border rounded bg-dark text-white fw-bold mx-3 px-5 my-2"
          {...a11yProps(1)}
        />
        <Tab
          label="CloudBrain"
          className="border rounded bg-dark text-white fw-bold mx-3 px-5 my-2"
          {...a11yProps(1)}
        />
        <Tab
          label="DataPy"
          className="border rounded bg-dark text-white fw-bold mx-3 px-5 my-2"
          {...a11yProps(1)}
        />
      </Tabs>
      <Box sx={{ flexGrow: 1 }} className="border rounded mx-1">
        <TabPanel value={value} index={0}>
          <div className="">
            <div className="row d-flex justify-content-center">
              <div className="col-xl-5">
                <CourseWindow courses={[firstTabCourses[0]]} />
              </div>
              <div className="col-xl-1 d-none d-xl-block d-md-none text-center mt-5 pt-5">
                <div className="pt-5">
                  <FaPlus size="35px" color="black" />
                </div>
              </div>
              <div className="col-xl-1 d-none d-xl-none pt-5 d-md-block text-center">
                <div className="">
                  <FaPlus size="35px" color="black" />
                </div>
              </div>
              <div className="col-xl-5">
                <CourseWindow courses={[firstTabCourses[1]]} />
              </div>
            </div>
          </div>
          <div className="border rounded w-100 py-3 mt-4 px-5">
            <div className="combo_card_price">
              <h6>Original Price: 8,000 + 8,000 = ₹ 16,000</h6>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> 2
                Hands-on-Projects
              </h5>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> Live+Recorded
                Sessions
              </h5>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> 2 Certificate
              </h5>
              <h2>
                Combo Price: <s>₹ 16,000</s> (₹ 8,000)
              </h2>
              {/* <button className="px-4 py-2 bg-dark border rounded text-white">
                Enroll Now
              </button> */}
               <a href="https://rzp.io/rzp/QJ6FVvh" target="_blank" rel="noopener noreferrer">
                   <button class="px-4 py-2 bg-dark border rounded text-white">Enroll Now</button>
                   </a>
            </div>
          </div>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <div className="">
            <div className="row d-flex justify-content-center">
              <div className="col-xl-5">
                <CourseWindow courses={[secondTabCourses[0]]} />
              </div>
              <div className="col-xl-1 d-none d-xl-block d-md-none text-center mt-5 pt-5">
                <div className="pt-5">
                  <FaPlus size="35px" color="black" />
                </div>
              </div>
              <div className="col-xl-1 d-none d-xl-none pt-5 d-md-block text-center">
                <div className="">
                  <FaPlus size="35px" color="black" />
                </div>
              </div>
              <div className="col-xl-5">
                <CourseWindow courses={[secondTabCourses[1]]} />
              </div>
            </div>
          </div>
          <div className="border rounded w-100 py-3 mt-4 px-5">
            <div className="combo_card_price">
              <h6>Original Price: 8,000 + 8,000 = ₹ 16,000</h6>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> 2
                Hands-on-Projects
              </h5>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> Live+Recorded
                Sessions
              </h5>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> 2 Certificate
              </h5>
              <h2>
                Combo Price: <s>₹ 16,000</s> (₹ 8,000)
              </h2>
              {/* <button className="px-4 py-2 bg-dark border rounded text-white">
                Enroll Now
              </button> */}
              <a href="https://rzp.io/rzp/QJ6FVvh" target="_blank" rel="noopener noreferrer">
                   <button class="px-4 py-2 bg-dark border rounded text-white">Enroll Now</button>
                   </a>
              
            </div>
          </div>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <div className="">
            <div className="row d-flex justify-content-center">
              <div className="col-xl-5">
                <CourseWindow courses={[thiredTabCourses[0]]} />
              </div>
              <div className="col-xl-1 d-none d-xl-block d-md-none text-center mt-5 pt-5">
                <div className="pt-5">
                  <FaPlus size="35px" color="black" />
                </div>
              </div>
              <div className="col-xl-1 d-none d-xl-none pt-5 d-md-block text-center">
                <div className="">
                  <FaPlus size="35px" color="black" />
                </div>
              </div>
              <div className="col-xl-5">
                <CourseWindow courses={[thiredTabCourses[1]]} />
              </div>
            </div>
          </div>
          <div className="border rounded w-100 py-3 mt-4 px-5">
            <div className="combo_card_price">
              <h6>Original Price: 8,000 + 8,000 = ₹ 16,000</h6>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> 2
                Hands-on-Projects
              </h5>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> Live+Recorded
                Sessions
              </h5>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> 2 Certificate
              </h5>
              <h2>
                Combo Price: <s>₹ 16,000</s> (₹ 8,000)
              </h2>
              {/* <button className="px-4 py-2 bg-dark border rounded text-white">
                Enroll Now
              </button> */}
              <a href="https://rzp.io/rzp/QJ6FVvh" target="_blank" rel="noopener noreferrer">
                   <button class="px-4 py-2 bg-dark border rounded text-white">Enroll Now</button>
                   </a>
            </div>
          </div>
        </TabPanel>
        <TabPanel value={value} index={3}>
          <div className="">
            <div className="row d-flex justify-content-center">
              <div className="col-xl-5">
                <CourseWindow courses={[fourthTabCourses[0]]} />
              </div>
              <div className="col-xl-1 d-none d-xl-block d-md-none text-center mt-5 pt-5">
                <div className="pt-5">
                  <FaPlus size="35px" color="black" />
                </div>
              </div>
              <div className="col-xl-1 d-none d-xl-none pt-5 d-md-block text-center">
                <div className="">
                  <FaPlus size="35px" color="black" />
                </div>
              </div>
              <div className="col-xl-5">
                <CourseWindow courses={[fourthTabCourses[1]]} />
              </div>
            </div>
          </div>
          <div className="border rounded w-100 py-3 mt-4 px-5">
            <div className="combo_card_price">
              <h6>Original Price: 8,000 + 8,000 = ₹ 16,000</h6>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> 2
                Hands-on-Projects
              </h5>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> Live+Recorded
                Sessions
              </h5>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> 2 Certificate
              </h5>
              <h2>
                Combo Price: <s>₹ 16,000</s> (₹ 8,000)
              </h2>
              {/* <button className="px-4 py-2 bg-dark border rounded text-white">
                Enroll Now
              </button> */}
              <a href="https://rzp.io/rzp/QJ6FVvh" target="_blank" rel="noopener noreferrer">
                   <button class="px-4 py-2 bg-dark border rounded text-white">Enroll Now</button>
                   </a>
            </div>
          </div>
        </TabPanel>
        <TabPanel value={value} index={4}>
          <div className="">
            <div className="row d-flex justify-content-center">
              <div className="col-xl-5">
                <CourseWindow courses={[fifthTabCourses[0]]} />
              </div>
              <div className="col-xl-1 d-none d-xl-block d-md-none text-center mt-5 pt-5">
                <div className="pt-5">
                  <FaPlus size="35px" color="black" />
                </div>
              </div>
              <div className="col-xl-1 d-none d-xl-none pt-5 d-md-block text-center">
                <div className="">
                  <FaPlus size="35px" color="black" />
                </div>
              </div>
              <div className="col-xl-5">
                <CourseWindow courses={[fifthTabCourses[1]]} />
              </div>
            </div>
          </div>
          <div className="border rounded w-100 py-3 mt-4 px-5">
            <div className="combo_card_price">
              <h6>Original Price: 8,000 + 8,000 = ₹ 16,000</h6>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> 2
                Hands-on-Projects
              </h5>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> Live+Recorded
                Sessions
              </h5>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> 2 Certificate
              </h5>
              <h2>
                Combo Price: <s>₹ 16,000</s> (₹ 8,000)
              </h2>
              {/* <button className="px-4 py-2 bg-dark border rounded text-white">
                Enroll Now
              </button> */}
              <a href="https://rzp.io/rzp/QJ6FVvh" target="_blank" rel="noopener noreferrer">
                   <button class="px-4 py-2 bg-dark border rounded text-white">Enroll Now</button>
                   </a>
            </div>
          </div>
        </TabPanel>
        <TabPanel value={value} index={5}>
          <div className="">
            <div className="row d-flex justify-content-center">
              <div className="col-xl-5">
                <CourseWindow courses={[sixTabCourses[0]]} />
              </div>
              <div className="col-xl-1 d-none d-xl-block d-md-none text-center mt-5 pt-5">
                <div className="pt-5">
                  <FaPlus size="35px" color="black" />
                </div>
              </div>
              <div className="col-xl-1 d-none d-xl-none pt-5 d-md-block text-center">
                <div className="">
                  <FaPlus size="35px" color="black" />
                </div>
              </div>
              <div className="col-xl-5">
                <CourseWindow courses={[sixTabCourses[1]]} />
              </div>
            </div>
          </div>
          <div className="border rounded w-100 py-3 mt-4 px-5">
            <div className="combo_card_price">
              <h6>Original Price: 8,000 + 8,000 = ₹ 16,000</h6>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> 2
                Hands-on-Projects
              </h5>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> Live+Recorded
                Sessions
              </h5>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> 2 Certificate
              </h5>
              <h2>
                Combo Price: <s>₹ 16,000</s> (₹ 8,000)
              </h2>
              {/* <button className="px-4 py-2 bg-dark border rounded text-white">
                Enroll Now
              </button> */}
              <a href="https://rzp.io/rzp/QJ6FVvh" target="_blank" rel="noopener noreferrer">
                   <button class="px-4 py-2 bg-dark border rounded text-white">Enroll Now</button>
                   </a>
            </div>
          </div>
        </TabPanel>
        <TabPanel value={value} index={6}>
          <div className="">
            <div className="row d-flex justify-content-center">
              <div className="col-xl-5">
                <CourseWindow courses={[sevenTabCourses[0]]} />
              </div>
              <div className="col-xl-1 d-none d-xl-block d-md-none text-center mt-5 pt-5">
                <div className="pt-5">
                  <FaPlus size="35px" color="black" />
                </div>
              </div>
              <div className="col-xl-1 d-none d-xl-none pt-5 d-md-block text-center">
                <div className="">
                  <FaPlus size="35px" color="black" />
                </div>
              </div>
              <div className="col-xl-5">
                <CourseWindow courses={[sevenTabCourses[1]]} />
              </div>
            </div>
          </div>
          <div className="border rounded w-100 py-3 mt-4 px-5">
            <div className="combo_card_price">
              <h6>Original Price: 8,000 + 8,000 = ₹ 16,000</h6>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> 2
                Hands-on-Projects
              </h5>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> Live+Recorded
                Sessions
              </h5>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> 2 Certificate
              </h5>
              <h2>
                Combo Price: <s>₹ 16,000</s> (₹ 8,000)
              </h2>
              {/* <button className="px-4 py-2 bg-dark border rounded text-white">
                Enroll Now
              </button> */}
              <a href="https://rzp.io/rzp/QJ6FVvh" target="_blank" rel="noopener noreferrer">
                   <button class="px-4 py-2 bg-dark border rounded text-white">Enroll Now</button>
                   </a>
            </div>
          </div>
        </TabPanel>
        <TabPanel value={value} index={7}>
          <div className="">
            <div className="row d-flex justify-content-center">
              <div className="col-xl-5">
                <CourseWindow courses={[eightTabCourses[0]]} />
              </div>
              <div className="col-xl-1 d-none d-xl-block d-md-none text-center mt-5 pt-5">
                <div className="pt-5">
                  <FaPlus size="35px" color="black" />
                </div>
              </div>
              <div className="col-xl-1 d-none d-xl-none pt-5 d-md-block text-center">
                <div className="">
                  <FaPlus size="35px" color="black" />
                </div>
              </div>
              <div className="col-xl-5">
                <CourseWindow courses={[eightTabCourses[1]]} />
              </div>
            </div>
          </div>
          <div className="border rounded w-100 py-3 mt-4 px-5">
            <div className="combo_card_price">
              <h6>Original Price: 8,000 + 8,000 = ₹ 16,000</h6>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> 2
                Hands-on-Projects
              </h5>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> Live+Recorded
                Sessions
              </h5>
              <h5>
                <FiArrowRightCircle size="20px" color="#00FF00" /> 2 Certificate
              </h5>
              <h2>
                Combo Price: <s>₹ 16,000</s> (₹ 8,000)
              </h2>
              {/* <button className="px-4 py-2 bg-dark border rounded text-white">
                Enroll Now
              </button> */}
              <a href="https://rzp.io/rzp/QJ6FVvh" target="_blank" rel="noopener noreferrer">
                   <button class="px-4 py-2 bg-dark border rounded text-white">Enroll Now</button>
                   </a>
            </div>
          </div>
        </TabPanel>
      </Box>
    </Box>
  )
}
